module.exports = __webpack_public_path__ + "icon1.66a2fc7c.gif";